import { makeStyles } from "@fluentui/react-components";
import React from "react";
import { Link } from "react-router-dom";
import { $cloud100 } from "../../cssjs/colors";
import PageEnum from "../../enum/PageEnum";
import { EventsCard } from "../shared/components/airport-cards/EventsCard";
import { FlightCard } from "../shared/components/airport-cards/FlightCard";
import { HealthOfOperationsCard } from "../shared/components/airport-cards/HealthOfOperationsCard";
import { PaxCard } from "../shared/components/airport-cards/PaxCard";
import { ResourcesUtilisationCard } from "../shared/components/airport-cards/resources/ResourcesUtilisationCard";
import { WeatherCard } from "../shared/components/airport-cards/WeatherCard";
import PaxSecurity from "./overview-cards/pax-security/PaxSecurity";
import ResourceAvailability from "./overview-cards/resources-availability/ResourceAvailability";

interface IOverviewXYZProps {
  airport: string;
}

export const OverviewXYZ: React.FC<IOverviewXYZProps> = ({ airport }) => {
  const classes = useStyles();

  return (
    <>
      <section className="card1" data-testid="weatherCard">
        <Link
          to={`/${PageEnum.PageUrl.Weather}`}
          style={{ textDecoration: "none" }}
        >
          <WeatherCard />
        </Link>
      </section>

      <section className="card2" data-testid="flightCard">
        <Link
          to={`/${PageEnum.PageUrl.Flights}`}
          style={{ textDecoration: "none" }}
        >
          <FlightCard airportCode={airport} />
        </Link>
      </section>

      <ResourceAvailability airport={airport} />

      <section className="card3" data-testid="paxCard">
        <Link
          to={`/${PageEnum.PageUrl.Passenger}`}
          style={{ textDecoration: "none" }}
        >
          <PaxCard airport={airport} />
        </Link>
      </section>

      <PaxSecurity airport={airport} />

      <section
        className={`${classes.cardContainer} ${classes.card8} card8`}
        data-testid="healthOfOperationsCard"
      >
        <HealthOfOperationsCard airport={airport} />
      </section>
    </>
  );
};

const useStyles = makeStyles({
  cardContainer: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    "&.card6": { gridTemplateColumns: "1fr" },
    "&.card8": { gridTemplateColumns: "1fr auto" },
    color: $cloud100,
  },
  card7: {
    display: "grid",
    gridTemplateColumns: "auto",
    gridColumn: "span 3",
    width: "100%",
  },
  card8: {
    gridColumn: "1 / -1",
  },
});
